export default function buildQueryString(properties) {
  if (!window) return null;
  const newParams = new URLSearchParams(window.location.search);

  Object.entries(properties).forEach(([key, value]) => {
    if (value) newParams.set(key, value);
  });

  return decodeURIComponent(newParams.toString());
}
